// extracted by mini-css-extract-plugin
export default {"content":"PJ-z","lookName":"QJ-z","shopTheLookContainer":"RJ-z","productContainer":"SJ-z","imageContainer":"TJ-z","mainImage":"UJ-z"};